import { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import { postStrip } from '../../Services/stripServices';
import SubscriptionForm from './SubscriptionForm';

const stripePromise = loadStripe('pk_test_51Lcpz9JaQ38yVOQoH2XbSGeAlLyiVBavaO7AxnBYt4p8cr5pXqQvNXNBlzDnAQDIvjCgeWwCT9zJIR4vft02hLYm00kV1gveR9');

const SubscriptionStripComp = () => {
    const [clientSecret, setClientSecret] = useState(null);

    const handleSubmit = async () => {
        // e.preventDefault();
        // setIsLoading(true);

        let response = await postStrip({ total_amount: 100 });
        if (response.statusCode === 200) {
            setClientSecret(response?.response?.data?.client_secret)
            console.log("strip response ", response)
            // setCoupone(response?.response?.data);
            // setCode("");
            // setDiscountAmount(newDiscountAmount);
            // localStorage.setItem('discountedAmount', newDiscountAmount); // Store correct value
            // toast.success(response.message);
        } else if (response.statusCode === 401) {
            // toast.error(response.errors);
        } else {

            // Object.values(response.errors).forEach(error => {
            //     toast.error(error);
            // });
        }

        // setIsLoading(false);
    };

    useEffect(() => {
        handleSubmit();
    }, []);

    if (!clientSecret) {
        return <p>Loading...</p>;
    }

    return (
        <>
            {clientSecret && <>
                <Elements stripe={stripePromise} options={{ clientSecret }}>
                    <SubscriptionForm />
                </Elements>
            </>}
        </>
    );
};

export default SubscriptionStripComp;
